import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';

import { getNodeTitle } from 'services/getNodeTitle';
import { CamIcon, CaretIcon } from './icons';
import { Widget, WHead, WIco, WTitle, Chip, Caret, WBody, Row, Dot, RackId, Grow, PlateTag, Empty } from './widgets-dock.styled';

export const GrzWidget = ({ open, onToggle }) => {
  const { t } = useTranslation();
  const unrecognized = useSelector((store) => store.events.unrecognized, shallowEqual);

  const active = !!(unrecognized && unrecognized.source !== undefined);
  const node = active && window.config.nodes ? window.config.nodes[unrecognized.source] : null;
  const plate = active ? unrecognized.data && unrecognized.data.vehicle_plate_mean : null;

  return (
    <Widget className={active ? 'alert' : ''}>
      <WHead type="button" className={open ? '' : 'closed'} onClick={onToggle}>
        <WIco>
          <CamIcon />
        </WIco>
        <WTitle>{t('dock.Контроль ГРЗ')}</WTitle>
        {active ? <Chip className="blue">1</Chip> : <Chip className="ghost">0</Chip>}
        <Caret className={open ? 'open' : ''}>
          <CaretIcon />
        </Caret>
      </WHead>
      {open && (
        <WBody>
          {!active && <Empty>{t('dock.Нет ожидающих подтверждения')}</Empty>}
          {active && (
            <Row>
              <Dot className="blue" />
              <RackId>{node ? getNodeTitle(node.type, node.id, node.caption) : unrecognized.source}</RackId>
              <Grow>{plate ? '' : t('dock.ожидает решения')}</Grow>
              {plate && <PlateTag>{plate}</PlateTag>}
            </Row>
          )}
          {active && <Empty style={{ padding: '4px 2px 0', color: '#7a838a', fontSize: '11px' }}>{t('dock.Окно сверки открыто на схеме — подтвердите или запретите проезд')}</Empty>}
        </WBody>
      )}
    </Widget>
  );
};
